<script lang="ts">
	import type { Snippet } from 'svelte';
	import type { ClassValue, HTMLAttributes } from 'svelte/elements';

	interface Props extends HTMLAttributes<HTMLTableCellElement> {
		cellClass?: ClassValue;
		children?: Snippet;
	}

	const { cellClass, children, ...restProps }: Props = $props();
</script>

<td
	{...restProps}
	class={cellClass}
>
	{@render children?.()}
</td>
